import { TourFieldPermissions } from "@/onboarding/features/bidding/types"

const tourLabel = ({ tourName, tourCodes, tourBrands }: TourFieldPermissions): string => {
  const coded = tourCodes.length > 0 ? `${tourCodes.join("/")}: ${tourName}` : tourName

  if (tourBrands.length === 0) {
    return coded
  }

  return `${coded} — ${tourBrands.join("/")}`
}

export default tourLabel
